import { type Country } from 'react-phone-number-input';

import { getDefaultCountry, getPhoneLabels } from './PhoneField.helpers';
import { ArrowIcon, StyledMiniPhone } from './PhoneField.styles';

export const EmptyComponent = () => null;

export const InternationalIcon = () => <StyledMiniPhone width={18} height={18} />;

export const defaultCountry: Country | undefined = getDefaultCountry();
export const phoneLabels: Record<Country | 'ZZ', string> = getPhoneLabels();

export const countrySelectProps = {
    arrowComponent: () => <ArrowIcon size={12} />,
};
